import React, { useEffect, useState } from "react";
import { Controller, useFieldArray } from "react-hook-form";
import { Box, Typography, IconButton } from "@mui/material";
import { Button } from "../../../../components/button/button";
import SelectField from "../../../../components/form-fields/select-field/select-field";
import TextInputField from "../../../../components/form-fields/text-input-field/text-input-form-field";
import AddIcon from "@mui/icons-material/Add";
import { getNextRolesCardId } from "../../../../services/countersService";
import { REVENUE_ACCOUNT_OPTIONS } from "../../../../constants/constants";

export default function ServiceGroupForm({ form, isEditMode = false }) {
  const {
    control,
    formState: { errors },
  } = form;

  const { fields, append } = useFieldArray({
    control,
    name: "roles",
  });

  // next role ID from counter
  const [nextRoleId, setNextRoleId] = useState(null);
  useEffect(() => {
    getNextRolesCardId().then((num) => setNextRoleId(num));
  }, []);

  // handler to add a new role
  const addRole = () => {
    if (nextRoleId == null) return;
    append({ id: nextRoleId, name: "", isNewRole: true });
    // fetch next for subsequent adds
    getNextRolesCardId().then((num) => setNextRoleId(num));
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      {/* Service Group Name */}
      <Controller
        name="name"
        control={control}
        rules={{ required: "Service group name is required" }}
        render={({ field }) => (
          <TextInputField
            {...field}
            label="Service Group Name"
            isRequired
            error={!!errors.name}
            helperText={errors.name?.message}
            disabled={isEditMode}
          />
        )}
      />
      <Controller
        name="revenueAccount"
        control={control}
        render={({ field }) => (
          <SelectField
            {...field}
            label="Revenue Account"
            error={!!errors.revenueAccount}
            helperText={errors.revenueAccount?.message}
            // disabled={isEditMode}
            options={REVENUE_ACCOUNT_OPTIONS}
          />
        )}
      />
      <Typography variant="body1">Roles*</Typography>

      {fields.map((roleField, index) => (
        <Box
          key={roleField.id}
          sx={{ display: "flex", alignItems: "flex-end", gap: 1 }}
        >
          <Controller
            name={`roles.${index}.name`}
            control={control}
            rules={{ required: "Role name is required" }}
            render={({ field }) => (
              <TextInputField
                {...field}
                placeholder="Role Name"
                error={!!errors.roles?.[index]?.name}
                helperText={errors.roles?.[index]?.name?.message}
                sx={{ flexGrow: 1 }}
                disabled={isEditMode && !roleField.isNewRole}
              />
            )}
          />

          <Button
            variant="outlined"
            startIcon={<AddIcon />}
            onClick={addRole}
          ></Button>
        </Box>
      ))}
    </Box>
  );
}
